// 医薬品情報ビジュアライザー - 挙動系のみのJS
// データ生成はLiquidで行うため、ここには挙動系（アニメーション、インタラクション）のみを含める
// ただし、JSONメタフィールド（patient_age_distribution）は例外として、JavaScriptでパースして表示

document.addEventListener('DOMContentLoaded', () => {
  // 年齢層の棒グラフを生成（JSONメタフィールドをパース）
  const ageBarChart = document.getElementById('age-bar-chart');
  if (ageBarChart) {
    const ageDistributionData = ageBarChart.getAttribute('data-age-distribution');
    if (ageDistributionData) {
      try {
        const ageDistribution = JSON.parse(ageDistributionData);
        const ageRanges = ['10-20', '20-30', '30-40', '40-50', '50+'];
        
        ageBarChart.innerHTML = ageRanges.map(ageRange => {
          const value = ageDistribution[ageRange] || 0;
          const percentage = value;
          
          return `
            <div class="age-bar-item">
              <span class="age-range-label">${ageRange}</span>
              <div class="age-bar-wrapper">
                <div class="age-bar" style="width: ${percentage}%"></div>
              </div>
              <span class="age-bar-value">${value}%</span>
            </div>
          `;
        }).join('');
      } catch (e) {
        console.error('Failed to parse age distribution data:', e);
      }
    }
  }
  
  // スクロール連動アニメーション（Intersection Observer）
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  };

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        sectionObserver.unobserve(entry.target);
        
        // セクション別のエフェクト発火
        if (entry.target.classList.contains('dv-checklist')) {
          animateChecklist(entry.target);
        } else if (entry.target.classList.contains('dv-drug-info-layout')) {
          animateDrugInfo(entry.target);
        } else if (entry.target.classList.contains('dv-mechanism')) {
          animateMechanism(entry.target);
        } else if (entry.target.classList.contains('dv-patient-stats')) {
          animatePatientStats(entry.target);
        } else if (entry.target.classList.contains('dv-nurse')) {
          animateNurse(entry.target);
        }
      }
    });
  }, observerOptions);

  // 各セクションを監視
  document.querySelectorAll('.dv-card').forEach(card => {
    sectionObserver.observe(card);
  });
});

// 1. チェックリスト：逐次チェックイン（上から順にポンポンと出てくる）
function animateChecklist(section) {
  const cards = section.querySelectorAll('.checklist-card');
  cards.forEach((card, index) => {
    setTimeout(() => {
      card.classList.add('checklist-card-visible');
    }, index * 100); // 0.1秒ずつ遅延（0.5秒以内に全表示）
  });
}

// 2. お薬情報：タグのホバー説明 + 軽い浮き上がり（既存のdrug-effect-itemに適用）
function animateDrugInfo(section) {
  const effectItems = section.querySelectorAll('.drug-effect-item');
  effectItems.forEach((item, index) => {
    setTimeout(() => {
      item.classList.add('drug-effect-item-visible');
    }, index * 150);
  });
}

// 3. 体内作用：SVG部位のソフトハイライト（スクロールで該当位置に来た瞬間に発光）
function animateMechanism(section) {
  const highlight = section.querySelector('.organ-highlight');
  if (highlight) {
    highlight.classList.add('organ-highlight-visible');
  }
}

// 4. 患者統計：円グラフのワンアクション描画（初回表示時のみ、0→指定％まで一度だけ描画）
function animatePatientStats(section) {
  const pieChart = section.querySelector('.pie-chart');
  if (pieChart && !pieChart.classList.contains('pie-chart-animated')) {
    pieChart.classList.add('pie-chart-animated');
    
    // 円グラフのパーセンテージを取得
    const chartInner = section.querySelector('.chart-inner');
    if (chartInner) {
      const percentage = parseInt(chartInner.textContent.replace('%', '')) || 0;
      if (percentage > 0) {
        // 円グラフのローディングアニメーション（conic-gradientを0%から指定%まで）
        animatePieChart(pieChart, percentage, section);
      }
    }
  }
}

// 円グラフのアニメーション（0%から指定%まで描画）
function animatePieChart(pieChart, targetPercentage, section) {
  // data属性から性別を取得
  const gender = pieChart.getAttribute('data-patient-gender') || 'male';
  
  const femaleColor = '#FF6B6B';
  const maleColor = '#4A90E2';
  
  // 初期状態を0%に設定
  if (gender === 'female') {
    pieChart.style.background = `conic-gradient(${femaleColor} 0%, ${maleColor} 0% 100%)`;
  } else {
    pieChart.style.background = `conic-gradient(${maleColor} 0%, ${femaleColor} 0% 100%)`;
  }
  
  const chartInner = section.querySelector('.chart-inner');
  if (chartInner) {
    chartInner.textContent = '0%';
  }
  
  let currentPercentage = 0;
  const duration = 1500; // 1.5秒
  const startTime = Date.now();
  
  const animate = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);
    currentPercentage = Math.floor(progress * targetPercentage);
    
    if (gender === 'female') {
      pieChart.style.background = `conic-gradient(${femaleColor} ${currentPercentage}%, ${maleColor} ${currentPercentage}% 100%)`;
    } else {
      pieChart.style.background = `conic-gradient(${maleColor} ${currentPercentage}%, ${femaleColor} ${currentPercentage}% 100%)`;
    }
    
    if (chartInner) {
      chartInner.textContent = `${currentPercentage}%`;
    }
    
    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      // 最終値を設定
      if (gender === 'female') {
        pieChart.style.background = `conic-gradient(${femaleColor} ${targetPercentage}%, ${maleColor} ${targetPercentage}% 100%)`;
      } else {
        pieChart.style.background = `conic-gradient(${maleColor} ${targetPercentage}%, ${femaleColor} ${targetPercentage}% 100%)`;
      }
      if (chartInner) {
        chartInner.textContent = `${targetPercentage}%`;
      }
    }
  };
  
  animate();
}

// 5. 看護師メッセージ：チャットUIの「ポンッ」表示（少し下からポンと出る、バウンスなし、1回のみ）
function animateNurse(section) {
  const nurseCard = section.querySelector('.nurse-card');
  if (nurseCard && !nurseCard.classList.contains('nurse-card-animated')) {
    nurseCard.classList.add('nurse-card-animated');
  }
}

